import { render, staticRenderFns } from "./RankingPanel.vue?vue&type=template&id=3505b49b&scoped=true"
import script from "./RankingPanel.vue?vue&type=script&lang=js"
export * from "./RankingPanel.vue?vue&type=script&lang=js"
import style0 from "./RankingPanel.vue?vue&type=style&index=0&id=3505b49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3505b49b",
  null
  
)

export default component.exports